import { TFunction } from 'react-i18next'
import * as yup from 'yup'

const walletEditSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object({
    walletName: yup.string().required(t('walletNameRequired')).max(40, t('walletNameLengthError')),
  })
}
export default walletEditSchema
